import { render, staticRenderFns } from "./bargainItem.vue?vue&type=template&id=74b3fab4&scoped=true"
import script from "./bargainItem.vue?vue&type=script&lang=js"
export * from "./bargainItem.vue?vue&type=script&lang=js"
import style0 from "./bargainItem.vue?vue&type=style&index=0&id=74b3fab4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b3fab4",
  null
  
)

export default component.exports